import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function SmoothScroll({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  useEffect(() => {
    // In het CMS geen Lenis: die kaapt het muiswiel waardoor drawers/panels niet scrollen
    if (isAdmin) return undefined;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    // Op touch-toestellen: native scroll (bespaart continue rAF-werk op mobiel)
    const coarse = window.matchMedia("(pointer: coarse)").matches;
    if (reduce || coarse) return undefined;

    let lenis;
    let rafId;
    let cancelled = false;
    // Lenis pas laden na de eerste paint (desktop only) — houdt het uit de hoofdbundel
    import("lenis").then(({ default: Lenis }) => {
      if (cancelled) return;
      lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
        smoothTouch: false,
      });
      const raf = (time) => {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      };
      rafId = requestAnimationFrame(raf);
    });

    return () => {
      cancelled = true;
      if (rafId) cancelAnimationFrame(rafId);
      if (lenis) lenis.destroy();
    };
  }, [isAdmin]);

  return children;
}
